/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_shipment">;
    readonly " $refType": "PdpRespShippingReturns_shipment";
};
export type PdpRespShippingReturns_shipment$data = PdpRespShippingReturns_shipment;
export type PdpRespShippingReturns_shipment$key = {
    readonly " $data"?: PdpRespShippingReturns_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipment",
      "args": null
    }
  ]
};
(node as any).hash = '068d48c4fa1782a753ba69b4f347427d';
export default node;
